import styled from 'styled-components';

export const PdpButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => (props.white ? '#ef4e5e' : '#fff')};
  outline: none;
  background: ${(props) =>
    props.showNewAddToCartButton || props.white ? '#fff' : '#ef4e5e'};
  color: ${(props) => (props.white ? '#ef4e5e' : '#fff')};
  text-align: center;
  width: ${(props) => (props.white ? '' : '100%')};
  height: 57px;
  line-height: 44px;
  border-radius: ${(props) =>
    props.white ? '4px' : props.desktop ? '4px' : '0'};
  font-size: 15px;
  font-weight: 600;
  margin: ${(props) => (props.white ? '20px 12px' : '16px 0 0')};
  position: ${(props) =>
    props.white ? 'relative' : props.desktop ? 'relative' : 'fixed'};
  bottom: ${(props) => (props.white ? 'auto' : props.desktop ? 'auto' : '0')};
  left: ${(props) => (props.white ? 'auto' : props.desktop ? 'auto' : '0')};
  z-index: ${(props) => (props.white ? 'auto' : props.desktop ? 'auto' : '99')};
  opacity: ${(props) => props.sizePopupButtons && '0.38'};
  overflow: hidden;
  border-top: ${(props) =>
    props.showNewAddToCartButton ? '2px solid rgba(0, 0, 0, 0.12)' : ''};

  .oldstrip {
    font-weight: 400;
  }

  @media (min-width: 720px) {
    cursor: ${(props) => (props.sizePopupButtons ? 'default' : 'pointer')};
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: ${(props) =>
      props.white ? 'hsl(0deg, 0%, 0%, 18%)' : 'rgba(255, 255, 255, 0.7)'};
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  transition: background 0.15s ease-in-out;

  // span {
  //     position: absolute;
  //     opacity: 0;
  //     top: 0;
  //     left: 0;
  //     background: linear-gradient(
  //         105deg,
  //         rgb(239, 78, 94) 7%,
  //         rgb(255 255 255) 14%,
  //         rgb(250, 118, 131) 21%,
  //         rgb(239, 78, 94) 28%
  //     );

  //     width: 120%;
  //     height: 100%;
  //     animation: move_continue 2s;
  //     animation-iteration-count: infinite;
  //     animation-delay: 1s;
  // }

  // @keyframes move_continue {
  //     0% {
  //         left: 0;
  //         opacity: 0;
  //     }
  //     5% {
  //         opacity: 0;
  //     }
  //     48% {
  //         opacity: 0.2;
  //     }
  //     80% {
  //         opacity: 0;
  //     }
  //     100% {
  //         left: 82%;
  //     }
  // }
`;

export const PdpButtonNew = styled.div`
  background: #fff;
`;

export const OfferStrip = styled.div`
  background: #ecffe8;
  height: 24px;
  width: 100%;
  position: fixed;
  bottom: 57px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  span {
    font-size: 10px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    position: absolute;
    white-space: nowrap;

    &.offer-transition {
      display: block;
      animation: ${(props) =>
        props.offers > 1 ? 'fadeSlideOut 3s ease-in-out' : 'none'};
      animation-fill-mode: ${(props) =>
        props.offers > 1 ? 'forwards' : 'none'};
    }
  }
  @keyframes fadeSlideOut {
    0% {
      opacity: 0;
      transform: translateX(20px);
    }
    10%,
    90% {
      opacity: 1;
      transform: translateX(0);
    }
    100% {
      opacity: 0;
      transform: translateX(-20px);
    }
  }
`;

export const NewAddToCartButton = styled.div`
  display: flex;
  align-items: center;
  .savings {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    line-height: 1.2;
    margin: 2px 12px;
    color: rgba(0, 0, 0, 0.8);

    p {
      font-size: 16px;
    }

    .priceFlex {
      display: flex;
      align-items: center;
      margin: 2px 0 5px 0;
      gap: 7px;

      .moreVarients {
        font-size: 10px;
        font-weight: 500;
        color: #ef4e5e;
      }

      .inclTaxes {
        font-size: 9px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
        margin-bottom: 4px;
      }
    }

    .beforeAndAfterPrices {
      display: flex;
      align-items: center;
      gap: 7px;
      margin: 5px 0;
      .strikeprice {
        color: rgba(0, 0, 0, 0.38);
        font-size: 13px;
        font-weight: 400;
        text-decoration: line-through;
        text-align: left;
      }
    }

    .discount {
      color: #fff;
      border: 1px solid #61ada5;
      border-radius: 5px;
      padding: 2px 5px;
      background: #61ada5;
      font-size: 9px;
      font-weight: 500;
    }
  }
  button {
    background: #ef4e5e;
    color: #fff;
    border: #ef4e5e;
    border-radius: 8px;
    position: absolute;
    right: 0;
    height: 42px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    margin: 2px 12px;
    width: 50%;
    font-family: 'Montserrat';
    cursor: pointer;
  }
`;

export const OutofStock = styled.button`
  display: block;
  width: 100%;
  position: ${(props) =>
    props.desktop || props.fromSizePopup ? 'static' : 'fixed'};
  bottom: ${(props) => (props.desktop || props.fromSizePopup ? 'auto' : '0')};
  left: ${(props) => (props.desktop || props.fromSizePopup ? 'auto' : '0')};
  z-index: 99;
  background: #d9d9d9;
  color: #fff;
  font-weight: 600;
  margin: 16px 0 0;
  height: 54px;
  line-height: 44px;
  border: none;
  outline: none;
  font-family: 'Montserrat';
`;

export const DesktopStyle = styled.div`
  display: ${(props) => (props.fromSizePopup ? '' : 'grid')};
  grid-template-columns: ${(props) =>
    props.stockout ? 'repeat(1,1fr)' : 'repeat(2, 1fr)'};
  grid-gap: 16px;
  width: ${(props) =>
    props.fromSizePopup || props.allReviews ? '100%' : 'calc(100% - 100px)'};
  margin-left: ${(props) => (props.fromSizePopup ? '' : 'auto')};
  margin: ${(props) => (props.fromSizePopup ? 'auto' : '')};
  position: relative;
  @media (max-width: 720px) {
    display: none;
  }
`;

export const MobileStyle = styled.div`
  display: none;

  @media (max-width: 720px) {
    display: block;
    position: relative;
  }
`;

export const CheckOutOfferStrip = styled.div`
  position: fixed;
  bottom: 54px;
  background: #f1f1f1;
  text-align: center;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  z-index: 99;

  p {
    font-size: 12px;
    color: hsl(0deg, 0%, 0%, 87%);
    padding-left: 4px;
  }
`;

export const NewBuyNowButton = styled.div`
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: #fff;
  justify-content: space-between;
  height: 45px;
  padding: 0 6px;
  border: 1px solid #fff;

  .buyNowButton {
    background: #ef4e5e;
    color: #fff;
    flex-grow: 1;
    margin-left: 42px;
    height: 39px;
    line-height: 39px;
    text-align: center;
    font-weight: 500;
    border-radius: 4px;
    font-size: 14px;
  }

  .saveAmount {
    font-size: 14px;
    font-weight: 500;
    color: #ef4e5e;
    padding: 0 6px;
  }
`;

export const FloatingWhatsapp = styled.a`
  position: fixed;
  bottom: 30px;
  left: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;
  cursor: pointer;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #f5fff6;
  border-radius: 10px;

  @media (max-width: 720px) {
    bottom: 74px;
    width: 145px;
    left: 16px;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
    }
    80% {
      box-shadow: 0 0 0 14px rgba(37, 211, 102, 0);
    }
  }

  .whatsappIcon {
    background: #25d366;
    color: white;
    font-size: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 0;
    height: 0;
    padding: clamp(22px, 3vw, 28px);
    text-decoration: none;
    border-radius: 50%;
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-timing-function: ease-out;
    animation-iteration-count: infinite;

    img {
      width: clamp(21px, 2vw, 26px);
      height: clamp(21px, 2vw, 26px);
    }
  }
`;

export const ChatwithUs = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 14px;

  img {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }

  span {
    font-size: 12px;
    color: hsl(0deg, 0%, 0%, 87%);
    font-weight: 500;
  }
`;

export const BtnSkeleton = styled.div`
  position: fixed;
  bottom: -2px;
  left: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  height: 48px;
`;
